import { render, staticRenderFns } from "./DeviceFilterAndDetailsReviews.vue?vue&type=template&id=d10980e0"
import script from "./DeviceFilterAndDetailsReviews.vue?vue&type=script&lang=js"
export * from "./DeviceFilterAndDetailsReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports